import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgExternalLink = (props) => /* @__PURE__ */ _jsx("svg", {
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M31 24h-2c-.563 0-1 .5-1 1v7H8V12h9c.5 0 1-.438 1-1V9c0-.5-.5-1-1-1H7a3 3 0 0 0-3 3v22c0 1.688 1.313 3 3 3h22a3 3 0 0 0 3-3v-8c0-.5-.5-1-1-1Zm2.625-20H23.75c-1 0-1.75.813-1.75 1.75v1.188c0 .937.75 1.687 1.688 1.687h.062L28 8.5 12.437 24c-.312.25-.5.625-.5 1.063 0 .375.188.75.5 1.062l1.438 1.438h.063c.25.312.624.437 1 .437.437 0 .812-.125 1.062-.438L31.5 12l-.125 4.25c0 1 .75 1.75 1.75 1.75h1.125c.938 0 1.75-.75 1.75-1.75V6.375A2.374 2.374 0 0 0 33.625 4Z" })
});
export default SvgExternalLink;
